'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:AppLicenseServiceCtrl
 * @description
 * # AppLicenseService
 * Service for thothAppApp
 */
angular.module('thothApp.services')
  .factory('AppLicense', ['$http', '$rootScope', 'domain', 'BaseService', 'toaster', function ($http, $rootScope, domain, BaseService, toaster)
  {
    var BASE_URL = domain.name + '/api/v1/app_licenses/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_URL,
      baseModelName: 'app_license'
    });

    baseService.downloadAppLicense = ((app_license_id) =>
    {
      return $http.get(BASE_URL + app_license_id + '/download_license_script');
    });

    baseService.error = function (error)
    {
      baseService.baseError(error);
    };

    baseService.copyText = function(text, successMessage = 'Copiado con éxito')
    {
      if (!text) {
        toaster.pop('error', 'No se pudo copiar el texto.');
        return
      }

      navigator.clipboard.writeText(text).then(function() {
        $rootScope.$apply(function() {
          toaster.pop('success', successMessage);
        });
      }).catch(function() {
        $rootScope.$apply(function() {
          toaster.pop('error', 'No se pudo copiar el texto. Intenta de nuevo');
        });
      });
    }

    return baseService;
  }]);
